module.exports = __webpack_public_path__ + "img/icon_vip@2x.a84af3c1.png";